import angular from 'angular';
import { MeurhBeneficiosReativacaoFormController } from './reativacao.form.controller';

export class MeurhBeneficiosReativacaoFormComponent implements angular.IComponentOptions {
    static selector = 'meurhBeneficiosReativacaoFormComponent';
    static controller = MeurhBeneficiosReativacaoFormController;
    static template = require('!!html-loader!./reativacao.form.html');
    static transclude = true;
    static bindings = {
        tipoBeneficio: '<',
        limitDate: '<?',
        limitEndDate: '<?',
        entity: '=',
        form: '<?',
        editable: '<'
    };
}
